import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { setConsent, trackEvent } from '../utils/analytics';

const STORAGE_KEY = 'cookie_consent';

export const CookieBanner: React.FC = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
    setConsent(true).then(() => trackEvent('cookie_consent_accepted'));
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <p className="cookie-banner__text">
        {t('cookie.text')}{' '}
        <Link to="/about?tab=privacy" className="cookie-banner__link">
          {t('cookie.learnMore')}
        </Link>
      </p>
      <button className="btn-transparent cookie-banner__btn" onClick={accept}>
        {t('cookie.accept')}
      </button>
    </div>
  );
};
